import { render, staticRenderFns } from "./submit_return.vue?vue&type=template&id=1c432a91"
import script from "./submit_return.vue?vue&type=script&lang=js"
export * from "./submit_return.vue?vue&type=script&lang=js"
import style0 from "./submit_return.vue?vue&type=style&index=0&id=1c432a91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports